import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import receiptModelApi from '~/services/receipt-model-api/receipt-model-api';

export default function useForcePayment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ reason, transferId }:
        { reason: string; transferId: string; }) => receiptModelApi.forceTransferPayment(transferId, reason),
    onError: (error: any) => {
      const status = error?.response?.status;
      const message = error?.response?.data?.message;

      const errorMessages = {
        400: 'A ação não é permitida para o status atual da transferência.',
        401: 'Não autorizado. Faça login novamente.',
        403: 'Sem permissão para executar esta ação.',
        422: 'Motivo inválido. Verifique os dados informados.',
      } as const;

      const errorMessage = errorMessages[status as keyof typeof errorMessages]
        || message
        || 'Erro inesperado ao forçar pagamento.';

      toast.error(errorMessage);
    },
    onSuccess: () => {
      toast.success('Pagamento solicitado com sucesso.');
      queryClient.invalidateQueries({ queryKey: ['receipt-model'] });
    },
    retry: 3,
    retryDelay: 1000,
  });
}
